module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/binding_sample/image11-f489a9e9696f10503b406a146407b973.png";